import axios from './http';

export function getShipmentsList(params, page) {
  return axios.get('shipments/index', { params: { ...params, page } });
}

export function getPopeyeShipmentsList(params) {
  return axios.get('shipments/popeye', { params: { ...params } });
}

export function getShipmentsHistoryList(params, page) {
  return axios.get('shipments/history', { params: { ...params, page } });
}

export function getShipment(shipment_id) {
  return axios.get(`shipments/${shipment_id}`);
}

export function starShipment(shipment_id) {
  return axios.post(`shipments/${shipment_id}/star`);
}

export function getShipmentsListTotals(params) {
  return axios.get('shipments/totals', { params });
}

export function getPopeyeShipmentsListTotals(params) {
  return axios.get('shipments/popeye_totals', { params });
}

export function receiveTrackingNotification(ids) {
  if (!Array.isArray(ids)) {
    ids = [ids];
  }
  return axios.post(`shipments/receive`, { ids });
}

export function getShippingLines(params) {
  return axios.get('shipments/shipping_lines', { params });
}

export function getSearchFormSelectors() {
  return axios.get('shipments/track_selectors');
}

export function getShipmentLabels(shipment_id) {
  return axios.get(`shipments/${shipment_id}/labels`);
}

export function addShipmentLabel(shipment_id, label) {
  return axios.post(`shipments/${shipment_id}/labels`, { label });
}

export function removeShipmentLabel(shipment_id, label) {
  return axios.delete(`shipments/${shipment_id}/labels/${label}`);
}

export function getShipmentFilters(params) {
  return axios.get('shipments/filters', { params });
}

export function calculate_route(shipmentId) {
  return axios.post('/shipments/calculate_route', { shipment_id: shipmentId });
}

export function getShipmentDetailsAttention(shipment_id) {
  return axios.get(`shipments/${shipment_id}/attentions`);
}

export function getShipmentDetailsUpdate(shipment_id) {
  return axios.get(`shipments/${shipment_id}/updates`);
}

export function getShipmentDetailsWatcher(shipment_id) {
  return axios.get(`shipments/${shipment_id}/watchers`);
}

export function updateWatchers(shipment_id, watchersData) {
  return axios.post(`shipments/${shipment_id}/update_watchers`, { watchers: watchersData });
}

export function deleteWatcher(shipment_id, watchersData) {
  return axios.post(`shipments/${shipment_id}/delete_watcher`, { watchers: watchersData });
}

export function getShipmentDetailsContainer(shipment_id) {
  return axios.get(`shipments/${shipment_id}/containers`);
}

export function getShipmentDetailsDocument(shipment_id) {
  return axios.get(`shipments/${shipment_id}/documents`);
}

export function getShipmentDetailsCost(shipment_id) {
  return axios.get(`shipments/${shipment_id}/cost`);
}

export function addTrackingShipment(params) {
  return axios.post('shipments/track', { ...params });
}

export function pollTrackingShipment(shipment_id) {
  return axios.get(`shipments/${shipment_id}/poll`);
}

export function convertAndTrackUploadedCsv(params) {
  return axios.post(`shipments/convert_and_track_uploaded_csv`, { ...params });
}

export function downloadTrackingSampleFile() {
  return axios.get(`shipments/generate_excel_tracking_sample`);
}

export function uploadShipmentDocuments(shipment_id, form) {
  return axios.post(`shipments/${shipment_id}/upload_documents`, form);
}

export function exportShipmentsCSV(params) {
  return axios.get('shipments/export', { params });
}

export function markShipmentComplete(shipment_id) {
  return axios.post(`shipments/${shipment_id}/mark_shipment_complete`);
}

export function markShipmentCancelled(shipment_id) {
  return axios.post(`shipments/${shipment_id}/cancel_shipment`);
}

export function getPartnerProfit() {
  return axios.get('shipments/partner_profit');
}

export function getAreas(params = {}) {
  return axios.get('locations/areas', { params });
}

export function getPorts(params = {}) {
  return axios.get('locations/ports', { params });
}

export function getContainers(params = {}) {
  return axios.get('shipments/container_types', { params });
}

export function getCurrencies(params = {}) {
  return axios.get('payment_items/currencies', { params });
}

export function createUpdate(shipment_id, values) {
  return axios.post(`shipments/${shipment_id}/create_update`, { update: values });
}

export function createShipment(values) {
  return axios.post('shipments', { shipment: values });
}

export function updateShipment(shipment_id, values) {
  return axios.put(`shipments/${shipment_id}`, { shipment: values });
}

export function create_failed_track_input(params) {
  return axios.post('shipments/create_failed_track_input', { ...params })
}

export function updatePaymentItem(payment_item_id, values) {
  return axios.put(`payment_items/${payment_item_id}`, { payment_item: values });
}

export function createPaymentItem(values) {
  return axios.post('payment_items', { payment_item: values });
}
